import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EmailGroup, EmailList, EmailSendReq, icJWT_Account, ReportRecord} from "../../../NIBINInterface";
import {EmailService} from "../../../services/email.service";
import {COMMA, ENTER, SEMICOLON, SPACE} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from "@angular/material/chips";
import {ReportService} from "../../../services/report.service";
import Swal from "sweetalert2";
import {AuthService} from "../../../services/auth.service";
@Component({
  selector: 'app-compose-email',
  templateUrl: './compose-email.component.html',
  styleUrls: ['./compose-email.component.css'],
  providers: [EmailService,ReportService]
})
export class ComposeEmailComponent implements OnInit {
  user: icJWT_Account = <icJWT_Account>{};
  @Input('ReportInfo') ReportInfo:ReportRecord = <ReportRecord>{}
  @Input('PrefillTo') PrefillTo : string[] | null = null
  @Input('PrefillSbj') PrefillSbj : string | null = null
  @Input('PrefillMsg') PrefillMsg : string | null = null
  @Output('SentEvent') SentEvent = new EventEmitter<boolean>();
  EmailGroups: EmailGroup[] = []

  emailSendForm:EmailSendReq = <EmailSendReq>{
    to:[""],
    cc:[""],
    bcc:[""],
    replyto:[""],
    files:[""],
    subject:"",
    message: "",
    includeLA: false,
  };
  EmailAttachment1: File | null = null;
  EmailAttachment2: File | null = null;
  EmailAttachment3: File | null = null;
  EmailAttachment4: File | null = null;
  EmailAttachment5: File | null = null;

  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA, SPACE, SEMICOLON] as const;

  constructor(private authService: AuthService,private emailService: EmailService,private reportService: ReportService) {
    this.user = this.authService.getUser()
  }


  ngOnInit(): void {
    this.loadEmailGroups();
    if(this.emailSendForm.to[0] ==="")
      this.emailSendForm.to.pop() //removes the default ""
    if(this.emailSendForm.cc[0] ==="")
      this.emailSendForm.cc.pop() //removes the default ""
    if(this.emailSendForm.bcc[0] ==="")
      this.emailSendForm.bcc.pop() //removes the default ""
    if(this.emailSendForm.replyto[0] ==="") {
      this.emailSendForm.replyto.pop() //removes the default ""
    }
    if(this.emailSendForm.files[0] ==="")
      this.emailSendForm.files.pop() //removes the default ""

    if(this.PrefillTo)
      this.emailSendForm.to = this.PrefillTo
    if(this.PrefillMsg)
      this.emailSendForm.message = this.PrefillMsg
    this.emailSendForm.forceSend = this.ReportInfo.ReportStatus?.toUpperCase() === 'RESEND' || this.ReportInfo.ReportStatus?.toUpperCase() === 'RESEND EMAIL' //Bypass the rate-limit check for Resend
    this.emailSendForm.subject = "***NIBIN ALERT"+((this.ReportInfo.ReportStatus?.toUpperCase() === 'RESEND' || this.ReportInfo.ReportStatus?.toUpperCase() === 'RESEND EMAIL') ? " UPDATE":"")+"*** " +(this.ReportInfo.NIBINHit? "HIT #":"POTENTIAL HIT #") + (this.ReportInfo.ReferenceNumber?this.ReportInfo.ReferenceNumber:"")
  }

  add(event: MatChipInputEvent, list:string): void {
    const emails_raw = (event.value || '').trim();
    let emails = emails_raw.split(',') //split email by ','
    for(let e of emails){
      if (e) {
        for (let email_adr of e.split(' ')){ //split email by '[SPACE]'
          for (let email_adr of e.split(';')){ //split email by ';'
            if(this.validateEmail(email_adr)){
              switch (list) {
                case 'to':
                  this.emailSendForm.to.push(email_adr);
                  break;
                case 'cc':
                  this.emailSendForm.cc.push(email_adr);
                  break;
                case 'bcc':
                  this.emailSendForm.bcc.push(email_adr);
                  break;
                case 'replyto':
                  this.emailSendForm.replyto.push(email_adr);
                  break;
                default:
                  break;
              }

            }
          }
        }
      }
    }
    event.chipInput!.clear();
  }

  remove(e: string, list:string): void {
    let index;
    switch (list) {
      case 'to':
        index = this.emailSendForm.to.indexOf(e);
        if (index >= 0)
          this.emailSendForm.to.splice(index, 1);
        break;
      case 'cc':
        index = this.emailSendForm.cc.indexOf(e);
        if (index >= 0)
          this.emailSendForm.cc.splice(index, 1);
        break;
      case 'bcc':
        index = this.emailSendForm.bcc.indexOf(e);
        if (index >= 0)
          this.emailSendForm.bcc.splice(index, 1);
        break;
      case 'replyto':
        index = this.emailSendForm.replyto.indexOf(e);
        if (index >= 0)
          this.emailSendForm.replyto.splice(index, 1);
        break;

      default:
        break;
    }

  }

  async loadEmailGroups(){
    this.EmailGroups = await this.emailService.getEmailGroups({});
    this.EmailGroups?.push({ID: 0, added_by_empid: 'SYSTEM', deptCode: 'SYSTEM', group: 'Default'});
    this.EmailGroups.sort();

    let ReplyToList:EmailList[] = await this.emailService.getReplyToEmailList({});
    if(ReplyToList && ReplyToList.length > 0){
      for(let r of ReplyToList){
        if(r.email && this.validateEmail(r.email)){
          this.emailSendForm.replyto.push(r.email)
        }
      }
    }else{
      if(this.validateEmail(this.user.EmailID)){
        this.emailSendForm.replyto.push(this.user.EmailID)
      }
    }

  }

  validateEmail(e:string):boolean{
    let regex = /\S+@\S+\.\S+/;
    return regex.test(e);
  }

  getBase64(file:File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  async sendEmail(){
    if(this.emailSendForm.to.length == 0){
      Swal.fire({
        icon: 'error',
        title: 'System Notification',
        text: 'Missing "TO" Email(s)',
        timerProgressBar:true,
        timer:4000
      })
      return;
    }

    if(this.ReportInfo.ReportID)
      this.emailSendForm.ReportID = this.ReportInfo.ReportID
    if(this.ReportInfo.ReportStatus?.toUpperCase() !== 'COMPLETE')
      this.reportService.updateReportStatus({ReportID: this.ReportInfo.ReportID, Status: 'COMPLETE'}).then(()=>{})

    /*
    Swal.fire({
      icon: 'info',
      title: 'Processing Email',
      text: 'An "Email Successfully Sent" message will appear when done processing',
      timerProgressBar:true,
      timer:10000
    })
    */

    if(this.emailSendForm && this.user.CurrentDept == 'MPDC'){
      this.emailSendForm.forceSend = true;
    }

    this.emailService.sendNIBINReportEmail(this.emailSendForm).then((r)=>{
      //close the dialog
      this.SentEvent.emit(true)
    }).catch(()=>{
      //Do not reset to PENDING if the email failed to send as it might have been a CloudFlare timeout issue
      //this.reportService.updateReportStatus({ReportID: this.ReportInfo.ReportID, Status: 'PENDING'}).then(()=>{})

      this.SentEvent.emit(true)

    })

  }

  async importEmailFromGroup(g: EmailGroup, list:string) {

    let emailsToAdd = await this.emailService.getEmailListInGroup(g.group? g.group: "Default")

    if(emailsToAdd){
      for(let e of emailsToAdd) {
        if (e.email && this.validateEmail(e.email)) {
          switch (list) {
            case 'to':
              this.emailSendForm.to.push(e.email);
              break;
            case 'cc':
              this.emailSendForm.cc.push(e.email);
              break;
            case 'bcc':
              this.emailSendForm.bcc.push(e.email);
              break;
            case 'replyto':
              this.emailSendForm.replyto.push(e.email);
              break;
            default:
              break;
          }
        }
      }
    }
  }


  UploadFile(file: any, number: number) {


    this.getBase64(file.target.files[0]).then(
      (data:any) => {
        this.emailSendForm.files.push(data)

      }
    );


  }
}
